<template>
    <div class="table_wrap">
        <el-table class="list-table" header-cell-class-name="list-header"
                  style="width: 100%;" height="695" empty-text="데이터가 없습니다."
                  :data="competitionData"
        >
            <el-table-column
                class="table_no"
                type="index"
                label="No"
                width="90"
                class-name="num text-center"
                :index="tableIdx"
            >
            </el-table-column>
            <el-table-column label="제목" width="" class-name="text-center" prop="Item.i_name"></el-table-column>
            <el-table-column label="창작자" width="" class-name="text-center"
                             prop="Item.originator_nick"></el-table-column>
            <el-table-column label="득표수" width="" class-name="text-center" prop="c_end_time">
                <template slot-scope="scope">
                    <span>{{ returnCommas(scope.row.ci_vote_cnt) }}({{returnPercentage(scope.row.ci_vote_cnt, scope.row.totalVote) }}%)</span>
                </template>
            </el-table-column>
            <el-table-column label="응모일시" width="" class-name="text-center" prop="c_end_time">
                <template slot-scope="scope">
                    <span>
                        {{ returnDateFormat(scope.row.created_at, 'YYYY-MM-DD HH:mm') }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                label="심사정보" width="" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info ">
                        <div class="row-info pointer" @click="openJudgeModal(scope.row.ci_idx)">
                            [상세]
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="옵션" width="" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info ">
                        <div class="row-info pointer" @click="moveDetail(scope.row.i_idx)">
                            [상세]
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import dateMixins from "@/mixins/dateMixins";

export default {
    name: "CompetitionListEntryLayout",
    mixins: [dateMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        competitionData: {
            type: Array,
            default: () => {
                return []
            }
        },
        paginationData: {
            type: Object,
            default: () => {
                return {total: 0, page: 0, size: 0,}
            }
        },
    },
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        openModal(name) {
            this.$modal.show(name);
        },
        moveDetail(idx) {
            this.$router.push(`/item/list/${idx}`);
        },
        tableIdx(index) {
            return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
        },
        returnCommas(x = 0) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        returnPercentage(v, t) {
            if (t !== 0) {
                return parseFloat((v / t * 100).toFixed(2))
            } else {
                return 0
            }
        },
        openJudgeModal(ci_idx){
            this.$modal.show('judge-info-modal',{'ci_idx':ci_idx})
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
